module.exports = __webpack_public_path__ + "img/logo.15f9b158.png";